import { Box, Button, Divider, styled } from "@mui/material";

export const CustomLinkContainer = styled(Box)(() => ({
  margin: "16px 0px",
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: '4px'
}));

export const CustomDivider = styled(Divider)(({ theme }) => ({
  color: theme.palette.secondary.main,
  margin: "16px 8px",
  "&:before": {
    borderColor: theme.palette.secondary.main,
    opacity: 0.5,
  },
  "&:after": {
    borderColor: theme.palette.secondary.main,
    opacity: 0.5,
  },
}));

export const LinkedInButton = styled(Button)(({ theme }) => ({
  background: "#007ab9",
  display: "flex !important",
  alignItems: "center !important",
  textTransform: "capitalize",
  color: "#fff",
}));

export const Image = styled("img")(() => ({
  height: "16px !important",
}));
